import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";

/** @param {object} options - `refreshInterval` (ms) không gửi lên API; còn lại là query params. */
function useWarehouseTransferSummary(options) {
  const { refreshInterval = 30_000, ...params } = options ?? {};
  return useSWR(
    !!params?.warehouse
      ? {
          path: `/api/v1/statistics/inventories`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
      refreshInterval,
    },
  );
}

export default useWarehouseTransferSummary;
